import { Component, Input, AfterViewChecked, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';


@Component({
    selector: 'jhi-abbreviate',
    templateUrl: './tooltips.component.html',
    styleUrls: ['./tooltips.component.scss']
})
export class TooltipsComponent implements AfterViewChecked {


    @Input() text: string;

    @ViewChild('container') container: ElementRef;

    isEllipsised = false;

    constructor(private cdRef: ChangeDetectorRef) { }

    ngAfterViewChecked() {
        this.isEllipsised = this.container.nativeElement.scrollWidth > this.container.nativeElement.clientWidth;
        this.cdRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/historique-requete/timeline/tooltips/tooltips.component.ts